import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/apps/fanychance/src/app/error.tsx");
